// @flow

import type {CssClassesType, TreeItem} from '../typedef';

export const parseCssClasses = (data: TreeItem): CssClassesType => {
    const {css_class: css = ''} = data;
    return {
        hidden: css.split(' ').includes('hidden'),
        bold: css.split(' ').includes('pb-c-dts-bold'),
        boldNoPadding: css.split(' ').includes('pb-c-dts-bold-no-pad')
    };
};
